import { SCALE_SLOTS } from '../helpers/DanmarksKortMap.constants.js'
import { buildLegendIndex, resolveLegendSlot } from '../helpers/DanmarksKortMap.legend.js'
import { indexByEntityKey, normalizeEntityKey } from '../helpers/DanmarksKortMap.helpers.js'

export function useMapColoring(caches, props = {}) {
  const legendIndex = buildLegendIndex(props.legend)

  const implicitSlots = new Map()

  const implicitSlotFor = (key) => {
    if (implicitSlots.has(key)) return implicitSlots.get(key)

    const asNumber = Number(key)
    const literal  = Number.isInteger(asNumber) && asNumber >= 1 && asNumber <= SCALE_SLOTS ? asNumber : null
    const taken    = new Set(implicitSlots.values())
    let   slot     = literal != null && !taken.has(literal) ? literal : null
    if (slot == null) {
      for (let candidate = 1; candidate <= SCALE_SLOTS; candidate++) {
        if (!taken.has(candidate)) { slot = candidate; break }
      }
    }
    if (slot != null) implicitSlots.set(key, slot)
    return slot
  }

  const slotFor = (value) => {
    if (value == null) return null
    const key = String(value).trim()
    if (key === '') return null
    return legendIndex.mode === 'implicit' ? implicitSlotFor(key) : resolveLegendSlot(legendIndex, key)
  }

  const applyColoringByAttr = (groupAttr, data, scopeRegion = null) => {
    const lookup = indexByEntityKey(data)
    const paint = (p) => {
      const slot = slotFor(lookup.get(normalizeEntityKey(p.dataset[groupAttr])))
      slot != null ? p.setAttribute('data-value', slot) : p.removeAttribute('data-value')
    }
    if (scopeRegion) {
      caches.region?.group.get(scopeRegion)?.forEach(paint)
      return
    }
    caches[groupAttr]?.group.forEach(paths => paths.forEach(paint))
  }

  const applyColoringFromLegend = (paths, groupAttr, data, legend) => {
    const index  = buildLegendIndex(legend)
    const lookup = indexByEntityKey(data)
    paths.forEach(p => {
      const slot = resolveLegendSlot(index, lookup.get(normalizeEntityKey(p.dataset[groupAttr])))
      slot != null ? p.setAttribute('data-value', slot) : p.removeAttribute('data-value')
    })
  }

  const greyExcept = (groupAttr, selectedKey) => {
    caches[groupAttr]?.group.forEach((paths, key) => {
      if (key !== selectedKey) paths.forEach(p => p.removeAttribute('data-value'))
    })
  }

  const legendEntries = legendIndex.entries

  return { applyColoringByAttr, applyColoringFromLegend, greyExcept, legendEntries }
}
